'use client';

import React from 'react';

export interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  function Icon(props, ref) {
    return (
      <svg
        ref={ref}
        focusable={false}
        aria-hidden="true"
        className={'size-16'}
        {...props}
      />
    );
  }
);
